module.exports = __webpack_public_path__ + "media/images/contacts-22388a2664ec1b21ab8cc59b6794aab8.png";